import React, { useState } from 'react';
import icon from '../assets/images/icons/Frame.svg';
import icon1 from '../assets/images/icons/Vector (1).svg';
import icon3 from '../assets/images/icons/Vector (3).svg';

import { BookButton, InputBox } from './';

const InputForm = () => {
  const [flight, setFlight] = useState({
    from: '',
    to: '',
    date: '',
    guests: '',
    ticketClass: '',
  });

  return (
    <form className="first-hero lws-inputform">
      <InputBox
        text="Destination From"
        icon={icon}
        name="from"
        id="lws-from"
        options={['Dhaka', 'Sylhet', 'Saidpur', "Cox's Bazar"]}
        setFlight={setFlight}
      />

      <InputBox
        text="Destination To"
        icon={icon}
        name="to"
        id="lws-to"
        options={['Dhaka', 'Sylhet', 'Saidpur', "Cox's Bazar"]}
        setFlight={setFlight}
      />

      <InputBox
        text="Journey Date"
        name="date"
        id="lws-date"
        setFlight={setFlight}
        date
      />

      <InputBox
        text="Guests"
        icon={icon1}
        name="guests"
        id="lws-guests"
        options={['1 Person', '2 Persons', '3 Persons', '4 Persons']}
        value={['1', '2', '3', '4']}
        setFlight={setFlight}
      />

      <InputBox
        text="Class"
        icon={icon3}
        name="ticketClass"
        id="lws-ticketClass"
        options={['Business', 'Economy']}
        setFlight={setFlight}
        last
      />

      <BookButton {...flight} />
    </form>
  );
};

export default InputForm;
